import React from "react"
import { motion } from "framer-motion"

type LayoutFadeAnimationProps = {
  initial?: any;
  animate?: any;
  exit?: any;
  transition?: any;
  style?: any;
  children: React.ReactNode;
}

export default function LayoutFadeAnimation(props: LayoutFadeAnimationProps) {
  const {
    initial = { opacity: 0, y: 0 },
    animate = { opacity: 1, y: 0 },
    exit = { opacity: 0, y: 0 },
    transition = {
      opacity: { duration: 0.2 },
      layout: { duration: 0.2, ease: "easeInOut" }
    },
    style = {},
    children
  } = props

  return (
    <motion.div
      layout
      initial={initial}
      animate={animate}
      exit={exit}
      transition={transition}
      style={style}
    >
      {children}
    </motion.div>
  )
}
